/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import NextJSLogo from "@/app/components/icons/nextJsLogo";
import FirebaseLogo from "@/app/components/icons/FirebaseLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function TJYadav() {
  const primaryColor = "#006039";
  useEffect(() => {
    // Dynamically add the Google font to the document head
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link); // Cleanup on unmount
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FTJFinancing%2Ftjyadavlogo.webp?alt=media&token=491246c3-9a7c-4f4e-b6a9-5ac03813731d" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FTJFinancing%2Ftjyadavbackground.webp?alt=media&token=fa84bf4b-f850-4d41-90cd-ad477b99869e",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For TJ Yadav, a broker agency, we delivered a sleek and modern website design aimed at enhancing their professional image and client engagement. The contemporary aesthetic ensures a user-friendly experience, reflecting the agency's commitment to current market standards and client service."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
            buttonHref=""
          />
        </div>
        <PortfolioTypography
          typographyData={[
            {
              headline: "All Your Business funding Solutions Start Here!",
              fontFamily: "Josefin Sans",
              fontSize: "36px",
              letterSpacing: "0%",
              lineHeight: "auto",
              textColor: "#2c2d2c",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#006039",
              rgb: "#006039",
              textColor: "#ffffff",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Black",
              color: "#2C2D2C",
              rgb: "#2C2D2C",
              textColor: "#FFFFFF",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FTJFinancing%2Ftjyadavpc.webp?alt=media&token=d17a66e8-544e-4f26-943a-4bc8f4bc295e",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FTJFinancing%2Ftjyadavipad.webp?alt=media&token=84375c05-3aa7-41ae-91c2-5c618f6b5456",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FTJFinancing%2Ftjyadavmobile.webp?alt=media&token=7ed2f786-5ef4-4dbf-ad3c-cc49cdc0117d",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              opacity: 5,
              icons: [<FigmaLogo />],
            },
            {
              title: "Layout Development",
              opacity: 15,
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
            },
            {
              title: "Server Setup",
              opacity: 25,
              icons: [<FirebaseLogo />],
            },
            {
              title: "Frontend Setup",
              icons: [<NextJSLogo />],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
